// extracted by mini-css-extract-plugin
export default {"title":"DuplicatesRemoveAllModal__title--19vva","description":"DuplicatesRemoveAllModal__description--2J18-"};